import { connect } from 'react-redux';
import * as actions from 'embed/actions';
import reducers from 'embed/reducers';
import PrepareCartForOffers from 'embed/components/PrepareCartForOffers'

export default connect(reducers, actions)(PrepareCartForOffers);
